import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=198e5171&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198e5171')) {
      api.createRecord('198e5171', component.options)
    } else {
      api.reload('198e5171', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=198e5171&", function () {
      api.rerender('198e5171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-287LMbitTW14O/JS/offershelp.vue"
export default component.exports